<template>
   <div>
     <!-- 主体内容 -->
    <el-row>
      <!-- title -->
      <div class="modt-box">商品管理</div>
      <el-col :span="6" class="btn"> 
        <el-input v-model="goods_id" placeholder="请输入商品ID" ></el-input>
        <el-button type="primary"  @click="getdouyin">更新</el-button> 
        
        </el-col>
    <el-alert
        title="错误提示"
        type="error"
        description="商品ID是必填项"
        v-show="is_tips"
        show-icon>
      </el-alert>
        <el-table size="small" :data="listData" highlight-current-row   border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column sortable   align="center" prop="p_id" label="商品ID" width="100">
      </el-table-column>
      <el-table-column sortable   align="center" prop="sku_id" label="规格ID" width="100">
      </el-table-column>
      <el-table-column sortable   align="center" prop="sku_name" label="规格名称" width="150">
      </el-table-column>

        <el-table-column sortable align="center" prop="sku_status" label="状态" width="80">
          <template slot-scope="scope">
        <el-tag
          :type="statusStyle(scope.row.sku_status)"
          disable-transitions>{{StateToStr(scope.row.sku_status)}}</el-tag>
      </template>
      </el-table-column>
        <el-table-column sortable  align="center" prop="create_time" label="创建时间" width="150">
      </el-table-column>
        <el-table-column sortable  align="center" prop="update_time" label="更新时间" width="150">
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editModule(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteModule(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
      
   
     

    </el-row>
    </div>   


</template>

<script>

import { goods_list,getdouyin } from '@/api/goods'
export default {
 
    data(){
        return{
            active_value:1,
            inactive_value:0,
            goods_id:'',
            addshow:true,
            is_tips:false,
            dialogVisible:false,
            showdelete:false,
            checkedId:'',
            form: {
             status:1,
             name:'',
             rules:[],
             },
             listData:[],
             
              // rules表单验证
            rules: {
                rules: [
                { required: true, message: '请选择权限', trigger: 'blur' }
                ],
                name: [
                { required: true, message: '请输入权限名称', trigger: 'blur' }
                ],
            },
        }
    },
    created(){
       
       this.getdata();
    },
   methods: {
    dialogClose(){
      this.dialogVisible=true;
      this.form="";
    },
   

   handleCheckedCitiesChange(value) {

        console.log(value);
        let checkedCount = value.length;
       // this.checkAll = checkedCount === this.cities.length;
       // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
    getdata(){
        goods_list().then(res=>{
            this.$nextTick(()=>{
              this.listData=res.data;
            });
                
        })
    },
    getdouyin(){
        if(!this.goods_id){
          this.is_tips=!this.is_tips;
          return ;
        }
        getdouyin({goods_id:this.goods_id}).then(res=>{
          this.getdata();
        })
    },
    // 复选变单选
    handleClick(data, checked, node) {
      if (checked) {
        this.addshow=false;
        this.checkedId=data.value;
        //this.$refs.tree.setCheckedNodes([])
        menuById(this.checkedId).then(res=>{
            this.form=res.data;
        });
        this.showdelete = true

      } else {
        this. clearForm('form');
        console.log(this.form);
        this.addshow=true;
        this.showdelete = false
      }
    },

     clearForm(form){
      //  this.$refs[form].resetFields();
        this.form.name="";
        this.form.rules="";
        this.dialogVisible=false;
        if(this.form.hasOwnProperty('id')){
            delete this.form.id;
        }

     },  
    
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          create_role(this.form)
            .then(res => {
             this.dialogClose();
              this.getdata();
              this.clearForm('form');
             // console.log(this.form);
            //   this.getmenu()
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteModule(index,row) {
      let deleteId={
        id:row['id'],
        };
      deleteRole(deleteId)
        .then(res => {
          this.getdata()
         this. clearForm('form');
          this.$message.error('删除成功！')
        })
    },

     // 编辑菜单
    editModule(index,row) {
      let editId={
        id:row['id'],
        };
      editRole(editId)
        .then(res => {
          this.$nextTick(()=>{
            this.form=res.data
          });
          
          this.dialogVisible=true;
          //this. clearForm('form');
         // this.$message.error('菜单管理列表删除成功！')
        })
    },


     statusStyle(status){
      if(status==1){
        return 'success';
      }else if(status==0){
          return 'info';
      }else{
        return 'danger';
      }
      
    },
    StateToStr(status){
      if(status==1){
        return '上架';
      }else if(status==0){
        return '下架';
      }
      else{
        return '未知状态';
      }
    }, 
  
   },

}
</script>
<style>
.btn{
  margin-bottom: 1.58rem;
  line-height: 3rem;
}
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/goods.vue